<template>
    <div class="search_page" id="searchPage">
        <div class="search_top">
            <p class="title">
                {{ languageNum == 3 ? '搜索' : 'Search' }}
            </p>

            <div class="search_box clearfix">
                <input type="text" class="form-control" v-model="keywords" @keyup.enter="searchClick()">
                <span class="search_btn" @click="searchClick()">
          <img src="../assets/search.png">
        </span>
            </div>
        </div>


        <div v-if="isNUll" style="text-align: center;padding: 80px">
            <img src="../assets/no-search.png" style="width: 200px">
            <p>没有搜索到相关内容~</p>
        </div>

        <b-container class="search_container" v-if="!isNUll">
            <div class="search_product">
                <p class="title">{{ title[0] }}</p>
                <b-row>
                    <b-col v-for="item in pageData.goods" :key="item.id" md="3" class="item"
                           @click="$router.push('/product/detail?id='+item.id)">
                        <div class="product_img">
                            <img :src="api + item.background" width="100%">
                        </div>
                        <p class="dec">{{ item.name }}</p>
                    </b-col>
                </b-row>
            </div>

            <div class="problem">
                <p class="title">{{ title[1] }}</p>
                <ul>
                    <li v-for="item in pageData.problems" :key="item.id" @click="goPage('/support/problem')">
                        {{ item.name }}
                    </li>
                </ul>
            </div>

            <div class="download_center">
                <p class="title">{{ title[2] }}</p>

                <div class="center">
                    <ul>
                        <li class="item" v-for="item in pageData.downloads" :key="item.id">
                            <div class="clamp1">{{ item.name }}</div>
                            <div class="clamp1 download_time">{{ item.updateTime || item.createTime }}</div>
                            <div class="download_btn" @click="downloadClick(item)">
                                <img src="../assets/cloud-download.png" width="16">
                                download
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </b-container>

        <transition name="fade">
            <div class="download_alert" v-if="alertStatus">
                <div class="alert-box">
                    <img src="../assets/alert_top.png" class="top_img">
                    <h4 class="title">{{ alertContent[languageNum - 1].title1 }}</h4>

                    <div class="content">
                        <p>{{ alertContent[languageNum - 1].title2 }}</p>

                        <p>
                            {{ alertContent[languageNum - 1].title3 }}
                        <p>
                            {{ alertContent[languageNum - 1].title4 }}
                        </p>
                        <b-form-select class="select" :options="options"></b-form-select>

                        <div class="more-btn" @click="downloadClick()">
                            <div class="box_inner">OK</div>
                        </div>
                    </div>
                    <img src="../assets/alert_bottom.png" class="left">
                </div>
            </div>
        </transition>

    </div>
</template>

<script>

    import {searchRequest, getTypeList} from "../api/HomeService"
    import {api} from "../api/api";

    export default {
        name: "Search",
        data() {
            return {
                alertContent: [
                    {
                        id: 1,
                        title1: 'Disclaimer',
                        title2: 'Dear Customers or Users.',
                        title3: 'Due to restrictions from the U.S. government, AIRDISK is not allowed to offer any upgrade services regarding certain types of firmware and/or software to U.S. customers or end-users. Therefore, we would appreciate your voluntary identification of citizenship by clicking applicable options. If you are a customer or end-user with U.S. citizenship or do not want to identify your citizenship, please leave this page immediately. For any U.S. customers, you may re-visit our website with a U.S. IP address to find other downloadable resources for AIRDISK products.',
                        title4: 'Your privacy is essential to us, so AIRDISK will not store or share any visitor’s IP address and/or record citizenship of visitors to our website in any way. The goal at Lexar is to provide the best products and services to our customers. We appreciate your patience and understanding.',
                        title5: 'Please choose your region'
                    },
                    {
                        id: 2,
                        title1: 'Disclaimer',
                        title2: 'Dear Customers or Users.',
                        title3: 'Due to restrictions from the U.S. government, AIRDISK is not allowed to offer any upgrade services regarding certain types of firmware and/or software to U.S. customers or end-users. Therefore, we would appreciate your voluntary identification of citizenship by clicking applicable options. If you are a customer or end-user with U.S. citizenship or do not want to identify your citizenship, please leave this page immediately. For any U.S. customers, you may re-visit our website with a U.S. IP address to find other downloadable resources for AIRDISK products.',
                        title4: 'Your privacy is essential to us, so AIRDISK will not store or share any visitor’s IP address and/or record citizenship of visitors to our website in any way. The goal at Lexar is to provide the best products and services to our customers. We appreciate your patience and understanding.',
                        title5: 'Please choose your region'
                    },
                    {
                        id: 3,
                        title1: '免责声明',
                        title2: '尊敬的客户或用户，',
                        title3: '根据美国政府的限制，AIRDISK不允许向其美国的客户或终端用户提供有关某些类型的固件和/或软件的任何升级服务。因此，我们感谢您自愿通过勾选并确认您的国籍。如果您是拥有美国国籍的客户或终端用户，或者您不想确认您所在的地区，请立即离开此页面。对于任何美国客户，您可以使用美国IP地址重新访问我们的网站，以便查找AIRDISK产品的可下载资源。',
                        title4: '您的隐私对我们至关重要，因此，AIRDISK不会存储或者共享任何访问者的IP地址和/或以任何方式记录访问我们网站的访问者的公民身份。我们的目标是为客户提供更好的产品和服务。我们感谢您的耐心和理解。',
                        title5: '请选择你的地区'
                    },
                    {
                        id: 4,
                        title1: '免責聲明',
                        title2: '親愛的用戶，',
                        title3: '根據美國政府的限制，AIRDISK不允許向其美國的客戶或終端用戶提供有關某些類型的固件和/或軟件的任何升級服務。因此，我們感謝您自願通過勾選並確認您的國籍。如果您是擁有美國國籍的客戶或終端用戶，或者您不想確認您所在的地區，請立即離開此頁面。對於任何美國客戶，您可以使用美國IP地址重新訪問我們的網站，以便查找AIRDISK產品的可下載資源。',
                        title4: '您的隱私對我們至關重要，因此，AIRDISK不會存儲或者共享任何訪問者的IP地址和/或以任何方式記錄訪問我們網站的訪問者的公民身份。我們的目標是為客戶提供更好的產品和服務。我們感謝您的耐心和理解。',
                        title5: '請選擇您的地區'
                    },
                    {
                        id: 5,
                        title1: 'Haftungsausschluss',
                        title2: 'Sehr geehrte Kunden oder Anwender,',
                        title3: 'Aufgrund US-amerikanischer Vorschriften ist es AIRDISK leider nicht erlaubt US-amerikanischen Kunden oder Endanwendern Upgrade-Dienste für bestimmte Arten von Firmware und/oder Software anzubieten. Daher möchten wir Sie bitten, freiwillig Ihre Staatsangehörigkeit auszuwählen und kenntlich zu machen, indem Sie oben auf die entsprechenden Optionen klicken. Sofern Sie ein Kunde oder Anwender mit US-amerikanischer Staatsangehörigkeit sind, oder Ihre Staatsangehörigkeit nicht kenntlich machen wollen, verlassen Sie diese Webseite bitte unverzüglich. Als US-amerikanischer Kunde können Sie unsere Website mit einer US-amerikanischen IP-Adresse erneut besuchen, um andere herunterladbare Ressourcen für AIRDISK-Produkte zu finden.',
                        title4: 'Ihre Privatsphäre ist für uns sehr wichtig, daher speichert oder teilt AIRDISK die IP-Adresse eines Besuchers nicht, noch wird die Staatsbürgerschaft der Besucher unserer Website auf irgendeine Weise aufgezeichnet. Bei Lexar sind wir stets darum bemüht, unseren Kunden immer die besten Produkte und Dienstleistungen zu bieten. Wir bedanken uns herzlich für Ihre Geduld und Ihr Verständnis.',
                        title5: 'Region wählen'
                    },
                    {
                        id: 6,
                        title1: 'Avis de non-responsabilité',
                        title2: 'Chers clients ou utilisateurs,',
                        title3: 'En raison des restrictions imposées par le gouvernement américain, AIRDISK n\'est pas autorisé à offrir des services de mise à niveau concernant certains types de microprogrammes et/ou de logiciels aux clients ou utilisateurs finaux américains. Par conséquent, nous vous serions reconnaissants de bien vouloir identifier volontairement votre citoyenneté en cliquant sur les options applicables. Si vous êtes un client ou un utilisateur final de citoyenneté américaine ou si vous ne voulez pas identifier votre citoyenneté, veuillez quitter cette page immédiatement. Pour les clients américains, vous pouvez visiter de nouveau notre site Web avec une adresse IP américaine pour trouver d\'autres ressources téléchargeables pour les produits AIRDISK.',
                        title4: 'Votre vie privée est essentielle pour nous, de sorte que AIRDISK ne stockera ni ne partagera l\'adresse IP d\'aucun visiteur et/ou n\'enregistrera la citoyenneté des visiteurs de notre site Web de quelque manière que ce soit. L\'objectif de Lexar est de fournir les meilleurs produits et services à ses clients. Nous vous remercions pour votre patience et votre compréhension.',
                        title5: 'Veuillez choisir une région'
                    },
                    {
                        id: 7,
                        title1: 'Esonero di responsabilità',
                        title2: 'Gentili clienti o utenti.',
                        title3: 'A causa di restrizioni del governo degli Stati Uniti, AIRDISK non ha il permesso di offrire aggiornamenti dei servizi rispetto a certi tipi di firmware e/o software a clienti o utenti finali negli Stati Uniti. Quindi vi saremmo grati se ci diceste, volontariamente, la vostra nazionalità, cliccando sulle rispettive opzioni. Se sei un cliente o un utente finale con cittadinanza statunitense o se non vuoi rivelare la tua cittadinanza, lascia subito questa pagina. I clienti degli Stati Uniti possono rivisitare il nostro sito da un IP degli Stati Uniti, per trovare altre risorse da scaricare per prodotti AIRDISK.',
                        title4: 'La vostra riservatezza è essenziale per noi. AIRDISK non salverà in alcun modo l\'IP né la cittadinanza di chi ha visitato il nostro sito. L\'obbiettivo di Lexar è fornire ai nostri clienti i migliori servizi e i migliori prodotti. Vi ringraziamo per la vostra pazienza e comprensione..',
                        title5: 'Scegli la tua Nazione'
                    },
                    {
                        id: 8,
                        title1: 'Renuncia',
                        title2: 'Estimados clientes o usuarios.',
                        title3: 'Debido a las restricciones del gobierno de los EE.UU., AIRDISK no puede ofrecer ningún servicio de actualización con respecto a ciertos tipos de firmware y/o software a los clientes o usuarios finales de los EE.UU. Por lo tanto, apreciamos su comunicación voluntaria de ciudadanía haciendo clic en las opciones correspondientes. Si usted es un cliente o usuario final con ciudadanía estadounidense o no desea comunicar su ciudadanía, abandone esta página inmediatamente. Para los clientes en EE.UU., pueden volver a visitar nuestro sitio web con una dirección IP de EE.UU. para encontrar otros recursos descargables para productos AIRDISK..',
                        title4: 'Su privacidad es esencial para nosotros, por lo que AIRDISK no almacenará ni compartirá la dirección IP de ningún visitante ni registrará la ciudadanía de los visitantes de nuestro sitio web de ninguna manera. El objetivo de Lexar es proporcionar los mejores productos y servicios a nuestros clientes. Apreciamos su paciencia y comprensión.',
                        title5: 'Elija su región'
                    },
                ],
                alertStatus: false,
                curItem: {},
                options: [],
                keywords: "",
                api: api,
                languageNum: window.localStorage.getItem("languageNum"),
                menuList: [],
                title: [],
                isNUll: true,
                pageData: {
                    goods: [],
                    problems: [],
                    downloads: []
                }
            }
        },

        methods: {

            goPage(url) {
                let lang = '/zh';

                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }

                this.$router.push(lang + url)
            },

            downloadClick(item) {
                this.curItem = item;
                let urlArr = this.curItem.url.split("/");
                // 创建a标签
                const link = document.createElement('a')
                // download属性
                link.setAttribute('download', urlArr[urlArr.length - 1])
                // href链接
                link.setAttribute('href', api + this.curItem.url)
                // 自执行点击事件
                link.click()
                document.body.removeChild(link)
                this.alertStatus = false
            },


            searchClick() {

                if (!this.keywords) {
                    this.isNUll = true
                    this.setHeight()
                    return
                }

                let sendData = {
                    languageNum: this.languageNum,
                    name: this.keywords
                }
                searchRequest(sendData, data => {
                    this.pageData = data
                    this.isNUll = !(this.pageData.problems.length || this.pageData.goods.length || this.pageData.downloads.length)

                    this.menuList = JSON.parse(window.localStorage.getItem("menuList"));

                    if (this.menuList) {
                        for (let i = 0; i < this.menuList.length; i++) {
                            if (this.menuList[i].menuUrl === "/products") {
                                this.title[0] = this.menuList[i].menuNam
                            }

                            if (this.menuList[i].children.length) {
                                for (let j = 0; j < this.menuList[i].children.length; j++) {

                                    if (this.menuList[i].children[j].menuUrl.indexOf('/server/problem') !== -1) {
                                        this.title[1] = this.menuList[i].children[j].menuNam
                                    }

                                    if (this.menuList[i].children[j].menuUrl.indexOf('/server/downloadcenter') !== -1) {
                                        this.title[2] = this.menuList[i].children[j].menuNam
                                    }
                                }
                            }

                        }
                    }

                    setTimeout(() => {
                        this.setHeight()
                    }, 200)

                })
            },

            setHeight() {
                let appDom = document.getElementById("searchPage");
                let footerDom = document.getElementById("footer");
                let windowH = document.documentElement.clientHeight;
                let appH = appDom.offsetHeight;
                let footerH = footerDom.offsetHeight
                console.log(windowH, (appH + footerH))
                if (windowH > (appH + footerH)) {
                    footerDom.style.position = 'fixed'
                } else {
                    footerDom.style.position = "unset"
                }
            },

        },

        destroyed() {
            let footerDom = document.getElementById("footer");
            footerDom.style.position = "unset"
        },

        mounted() {
            this.setHeight();
            if (this.$route.query.keywords) {
                this.keywords = this.$route.query.keywords;
                this.searchClick()
            }

            let sendData3 = {
                languageNum: this.languageNum,
                classType: 3
            }
            getTypeList(sendData3, data => {
                for (let i = 0; i < data.length; i++) {
                    data[i].text = data[i].name
                    data[i].value = data[i].id
                    this.options.push(data[i])
                }
            })

        }
    }
</script>

<style scoped lang="scss" src="../css/search.scss"></style>